import { createSlice } from "@reduxjs/toolkit";

const navHistoryState = createSlice({
  name: "navHistoryState",
  // 방문한 업무 탭(key) 이력 — Agent Chat 의 "이전 화면으로 돌아가기" 근거.
  // 맨 끝이 현재 화면(활성 탭). 연속 중복은 쌓지 않고 최근 20개만 유지.
  // persist 하지 않음(세션 내 이동 이력이면 충분 — 새로고침 시 초기화).
  initialState: { stack: [] },
  reducers: {
    pushVisitedTab: (state, action) => {
      const key = action.payload;
      if (key == null) return;
      if (state.stack[state.stack.length - 1] === key) return;
      state.stack.push(key);
      if (state.stack.length > 20) state.stack.shift();
    },
    clearVisitedTabs: (state) => { state.stack = []; },
  },
});

export const { pushVisitedTab, clearVisitedTabs } = navHistoryState.actions;
// 방문 스택 전체 — "이전 화면" 계산은 소비처에서 현재 탭 기준으로 걸러서 한다
//   (push 타이밍과 무관하게 정확하도록. App.js plannel:navScreen 참조)
export const getVisitedTabStack = (state) => state.navHistoryState.stack;
// 직전에 보던 탭 key (맨 끝은 현재 화면이므로 그 앞의 것)
export const getPrevVisitedTab = (state) => {
  const s = state.navHistoryState.stack;
  return s.length >= 2 ? s[s.length - 2] : null;
};
export default navHistoryState.reducer;
